import apiClient from "@/libs/axios";
import store from "@/state/store";
import router from "@/router";

export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result;
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, status: data.status} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/vendor-services/my-services${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async details({ commit }, data) {
        await apiClient
            .get(`api/v1/vendor-services/show?id=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async update({ commit }, data) {
        console.log(data);
        data = { vendor_id: store.state.profile.profile.basic.vendor.id, ...data };
        console.log(data);
        await apiClient
            .patch(`api/v1/vendor-services/update`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateDetails', response.data);
                    router.push({ name: "my-services" })
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async delete({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        console.log(data);
        await apiClient
            .delete(`api/v1/vendor-services/delete`, { id: data.id })
            .then(response => {
                if (response.status === 200) {
                    // router.push({ name: "my-services" })
                    commit('deleteItem', data.id);
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error
            });
    },
    async toggle({ commit }, data) {
        await apiClient
            .post(`api/v1/vendor-services/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async create({ commit }, data) {
        console.log(data);
        data = { vendor_id: store.state.profile.profile.basic.vendor.id, ...data };
        console.log(data)
        await apiClient
            .post(`api/v1/vendor-services/create`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
                console.log(response.data)
                if (response.status === 201) {
                    commit('updateData', response.data);
                    router.push({ name: "my-services" })
                }
            })
            .catch(error => {
                // this.toast.add({ severity: "error", summary: "Success", detail: error, life: 3000 }); // not working
                throw error;
            },);

    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
